import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DoFetchProvisioningDeviceById } from 'actions/provisioning';
import { RootState } from 'reducers';

// components
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import { DeviceProvisioningManagement } from 'components/Provisioning/DeviceProvisioningManagement';
import { FieldSkeleton } from 'components/Skeleton';

// styles
import { useInfoBlockStyles } from './InfoBlock/style';

interface Props {
  deviceId: string;
}

const DeviceProvisioningInfo: React.FC<Props> = ({ deviceId }) => {
  const infoCss = useInfoBlockStyles();
  const dispatch = useDispatch();
  const deviceProvisioning = useSelector((state: RootState) => state.provisioning.devices);

  const currentDevice = deviceProvisioning.devices.find(device => device.device_id.toUpperCase() === deviceId.toUpperCase());

  useEffect(() => {
    if (!currentDevice) {
      dispatch(DoFetchProvisioningDeviceById(deviceId));
    }
  }, [currentDevice, dispatch, deviceId]);

  if (!currentDevice || deviceProvisioning.isFetching) {
    return <FieldSkeleton className={ infoCss.field } />;
  }

  return (
    <Accordion>
      <AccordionSummary expandIcon={ <ExpandMore /> }>
        Device provisioning
      </AccordionSummary>

      <AccordionDetails>
        <DeviceProvisioningManagement device={ currentDevice } />
      </AccordionDetails>
    </Accordion>
  );
};

export default DeviceProvisioningInfo;
